import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IProductReportsGetAllParams } from "@api/stores/productReports/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IProductReportsGetAllParams
>("stores.productReports.exportExcel");

export const exportExcel = {
  ...getApis,
};
